export const MESSAGES = 'MESSAGES';
export const IS_AUTHENTICATED = 'IS_AUTHENTICATED';
export const SET_ALICE_HISTORY = 'SET_ALICE_HISTORY';
export const SET_BUOW_DETAILS = 'SET_BUOW_DETAILS';
export const SET_USER_INFO = 'SET_USER_INFO';
